import Repository from "./repository";

export default {
  index() {
    return Repository.get(`/initials`);
  },
};
